import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  effect,
  inject,
  input,
  OnInit,
  output,
  signal,
  WritableSignal,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AnimateModule, TrainingBrand, TrainingFormat, categoriesFilterByBrand } from '@pro-connect/shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { IPlace } from '../../../../models/place';
import { format } from 'date-fns';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { isEqual } from 'lodash-es';
import { TrainingsListService } from '../../trainings-list.service';

export type EventsFilterFormType = {
  category_id: FormControl<number | null>;
  format: FormControl<TrainingFormat | null>;
  brand: FormControl<TrainingBrand | null>;
};

export interface ISubCategory {
  categoryId: number;
  categoryName: string;
  subCategories: { id: number; name: string }[];
}

@Component({
  selector: 'app-trainings-categories',
  templateUrl: './trainings-categories.component.html',
  styleUrls: ['./trainings-categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, AnimateModule, ReactiveFormsModule, BsDatepickerModule],
})
export class TrainingsCategoriesComponent implements OnInit {
  public readonly categories = input.required<{ id: number; name: string }[]>();
  public readonly subCategories = input.required<ISubCategory[]>();
  public readonly brand = input<TrainingBrand | null>(null);
  public readonly categoryId = input<number | null>(null);
  public readonly subCategoryId = input<number | null>(null);
  // public subCategories: ISubCategory[] = [];

  public readonly filtersChanged = output<{
    category_id: number | null;
    sub_category_id: number | null;
  }>();

  public activeCategory: WritableSignal<number | null> = signal(null);
  public readonly categoriesByBrand = computed<ISubCategory[]>(() => {
    return categoriesFilterByBrand(this.subCategories(), this.brand());
  });
  public activeSubCategory: WritableSignal<number | null> = signal(null);

  constructor() {
    effect(() => {
      this.activeCategory.set(this.categoryId());
      // this._getAndSetSubCategories();
    });
  }

  public changeCategory(categoryId: number | null): void {
    this.activeCategory.set(categoryId === this.activeCategory() ? null : categoryId);
    this.activeSubCategory.set(null);
    this.filtersChanged.emit({ category_id: this.activeCategory(), sub_category_id: null });
  }

  public ngOnInit(): void {}

  public checkSubCategory(subCatId: number, catId: number): void {
    if (this.activeCategory() !== catId || !this.activeCategory()) {
      this.activeCategory.set(catId);
    }
    this.activeSubCategory.set(subCatId);
    this.filtersChanged.emit({ category_id: this.activeCategory(), sub_category_id: this.activeSubCategory() });
  }
}
